import { render } from "./SoundListPage.vue?vue&type=template&id=7746ce6c"
import script from "./SoundListPage.vue?vue&type=script&lang=js"
export * from "./SoundListPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__